import React from "react";
import clsx from "clsx";
import { Grid, Paper } from "@material-ui/core";
import { useStyles } from "features/admin/styles";
import Deposits from "features/admin/Deposits/Deposits";
import OrdersPreview from "features/admin/Orders/OrdersPreview";

const DashboardWidget = () => {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (
    <Grid container spacing={3}>
      {/* Recent Deposits */}
      <Grid item xs={12} md={4} lg={3}>
        <Paper className={fixedHeightPaper}>
          <Deposits />
        </Paper>
      </Grid>
      {/* Recent Orders */}
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <OrdersPreview />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default DashboardWidget;
